<template><!-- svgo-optimised -->
<svg class="icon icon__plus" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 11.5V4h1v7.5H20v1h-7.5V20h-1v-7.5H4v-1h7.5Z" fill-rule="evenodd" clip-rule="evenodd"/></svg></template>